export const setToken = (token) => localStorage.setItem('token',token)
export const setUserInfo = (userInfo) => localStorage.setItem('userInfo',JSON.stringify(userInfo))

export const getToken = () => localStorage.getItem('token')
export const getUserInfo = () => JSON.parse(localStorage.getItem('userInfo') || '{}')

export const clearToken = () => localStorage.removeItem('token')
export const clearUserInfo = () => localStorage.removeItem('userInfo')